import { Routes, RouterModule } from '@angular/router';
// Screens
import { BackendCallbackComponent } from './screens/backend-callback/backend-callback.component';
import { ForgotPasswordComponent } from './screens/forgot-password/forgot-password.component';
import { HomeComponent } from './screens/home/home.component';
import { UserProfileComponent } from './screens/user-profile/user-profile.component';
import { MeansOfPaymentRegistrationResultComponent } from './screens/means-of-payment-registration-result/means-of-payment-registration-result.component';
import { NotFoundComponent } from './screens/not-found/not-found.component';
import { PlayerComponent } from './screens/player/player.component';
import { PricingComponent } from './screens/pricing/pricing.component';
import { RecoverPasswordComponent } from './screens/recover-password/recover-password.component';
import { SignInComponent } from './screens/sign-in/sign-in.component';
import { SignUpComponent } from './screens/sign-up/sign-up.component';
import { SubscriptionResultComponent } from './screens/subscription-result/subscription-result.component';
import { SummaryAndSubscriptionConfirmationComponent } from './screens/summary-and-subscription-confirmation/summary-and-subscription-confirmation.component';
// Services
import { AuthenticationService } from './shared/services/authentication.service';
import { GeneralService } from './shared/services/general.service';
import { LoadingService } from './shared/services/loading.service';
import { PlanService } from './shared/services/plan.service';
import { PlaylistService } from './shared/services/playlist.service';
import { PreferenceService } from './shared/services/preference.service';
import { TeamService } from './shared/services/team.service';
import { UserService } from './shared/services/user.service';
// Guards
import { CanActivateGuard } from './shared/guards/can-activate.guard';

const appRoutes: Routes = [
  { path: '', redirectTo: 'planes', pathMatch: 'full'},
  {
    path: '',
    component: HomeComponent,
    children: [
      { path: 'backend-callback', component: BackendCallbackComponent },
      { path: 'planes', component: PricingComponent },
      { path: 'perfil-de-usuario', component: UserProfileComponent, canActivate: [ CanActivateGuard ] },
      { path: 'ingreso', component: SignInComponent },
      { path: 'registro', component: SignUpComponent },
      { path: 'olvido-password', component: ForgotPasswordComponent },
      { path: 'recuperar-password', component: RecoverPasswordComponent },
      { path: 'confirmacion-de-suscripcion', component: SummaryAndSubscriptionConfirmationComponent, canActivate: [ CanActivateGuard ] },
      { path: 'resultado-de-suscripcion', component: SubscriptionResultComponent, canActivate: [ CanActivateGuard ] },
      // tslint:disable-next-line:max-line-length
      { path: 'resultado-de-registro-de-medio-de-pago', component: MeansOfPaymentRegistrationResultComponent, canActivate: [ CanActivateGuard ] }
    ]
  },
  { path: 'player', component: PlayerComponent },

  { path: '**', component: NotFoundComponent }
];

// Exporto routing providers
export const AppRoutingProviders: any [] = [
  // Services
  AuthenticationService,
  GeneralService,
  LoadingService,
  PlanService,
  PlaylistService,
  PreferenceService,
  TeamService,
  UserService,
  // Guards
  CanActivateGuard
];

// Exporto modulo con lista de rutas
export const AppRouting = RouterModule.forRoot(appRoutes, {scrollPositionRestoration: 'enabled'});
